import CustomButton from 'components/buttons/CustomButton/CustomButton'
import AddIcon from 'icons/AddIcon'
import { useState } from 'react'
import ReimbursementDialog from '../ReimbursementDialog/ReimbursementDialog';
import { IconButton, useMediaQuery, useTheme } from '@mui/material';
import { colors } from 'styles/colors';

export default function AddReimbursementButton() {
  const [open, setOpen] = useState<boolean>(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {isMobile ? (
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            backgroundColor: colors.topBackground,
            width: 35,
            height: 35,
            borderRadius: '4px',
          }}
        >
          <AddIcon
            size={22}
            color={colors.primary}
          />
        </IconButton>
      ) : (
        <CustomButton
          text={`Add Reimbursement`}
          height={40}
          fontSize={14}
          startIcon={<AddIcon size={15} />}
          onClick={() => setOpen(true)}
        />
      )}

      <ReimbursementDialog
        open={open}
        setOpen={setOpen}
      />
    </>
  )
}
